import React from 'react';
import { Box } from 'components';
import { FilterCheckbox } from './FilterCheckbox';

export function TrainingFormatFilter({
  filterState: state,
  setFilterState: setState,
  stateKey = 'location',
  options = [
    { value: 'in-person', label: 'In person only' },
    { value: 'remote', label: 'Virtual / Remote' },
    { value: 'hybrid', label: 'Hybrid' },
  ]
}) {
  const currentValue = state[stateKey];

  return (
    <Box display="flex" flex={1} flexDirection="column" minWidth={160}>
      {options.map((option) => (
        <FilterCheckbox
          key={option.value}
          label={option.label}
          checked={currentValue === option.value}
          onChange={() =>
            setState({
              ...state,
              [stateKey]: currentValue === option.value ? undefined : option.value,
            })
          }
        />
      ))}
    </Box>
  );
}
